import { render, staticRenderFns } from "./TaxonomyPicker.vue?vue&type=template&id=26ae3998&"
import script from "./TaxonomyPicker.vue?vue&type=script&lang=js&"
export * from "./TaxonomyPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports